interface Props {
  children?: React.ReactNode;
}

export function FilterRow({ children }: Props) {
  return (
    <div className="flex flex-row items-end justify-start gap-2">
      {children}
    </div>
  );
}